import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Location } from '@angular/common';
import { ModalComponent } from '../../modal/modal.component';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';
import * as _ from 'lodash';
import { ObsolescencesPluginService } from './obsolescences-plugin.service';
import { map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { UpgradesMenuComponent } from '../../menus';

@Component({
    selector: 'obsolescences-edit',
    templateUrl: './obsolescences-edit.component.html',
    standalone: false
})
export class ObsolescencesEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pluginId: string;
  plugin: any;
  processing = false;
  obsolescences: any[];
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;

  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;
  public menuComponent = UpgradesMenuComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: ObsolescencesPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save() {
    this.processing = true;
    this.service.updateObsolescences(this.inspectionId, this.pluginId, this.obsolescences).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.obsolescences = this.plugin.config.Obsolescences ?? [];
      if (!this.obsolescences.length) {
        this.processing = true;
        this.loadData()
          .pipe(
            switchMap((obsolescences) => {
              this.obsolescences = obsolescences;
              if (this.obsolescences?.length) {
                return this.service.updateObsolescences(this.inspectionId, this.pluginId, this.obsolescences, {
                  ignoreLoader: 'true'
                });
              }
              return of(null);
            })
          )
          .subscribe(() => {
            this.processing = false;
            this.cdRef.detectChanges();
          });
      }
      this.cdRef.detectChanges();
    });
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      case 20:
        this.reloadData();
        break;
      default:
    }
  }

  reloadData() {
    this.obsolescences = [];
    this.processing = true;
    this.loadData().subscribe((obsolescences) => {
      this.obsolescences = obsolescences;
      this.processing = false;
      this.cdRef.detectChanges();
    });
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, null, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }

  update(obsolescence: any) {
    if (obsolescence.Status === 'already-installed' || obsolescence.Urgency === 'high') return;
    obsolescence.Recommended = !obsolescence.Recommended;
  }

  private loadData() {
    return this.service.getObsolescences(this.inspectionId, { ignoreLoader: 'true' }).pipe(
      map((obsolescences) => {
        obsolescences.forEach((obsolescence) => {
          if (obsolescence.Status !== 'already-installed') {
            obsolescence.Recommended = true;
          }
        });
        return obsolescences.map((o) => ({ ...o, Data: JSON.stringify(o) }));
      })
    );
  }
}
